export const HOME = {
  emergentLink: "home-emergent-link",
};

export const CARRIER_COORDINATION = {
  navRoot: "cc-nav",
  navLogo: "cc-nav-logo",
  navFreightIQ: "cc-nav-freightiq-link",
  navWorkspace: "cc-nav-workspace-link",
  navPrimaryCta: "cc-nav-primary-cta",

  hero: "cc-hero",
  heroEyebrow: "cc-hero-eyebrow",
  heroHeadline: "cc-hero-headline",
  heroSubheadline: "cc-hero-subheadline",
  heroDescription: "cc-hero-description",
  heroPrimaryCta: "cc-hero-primary-cta",
  heroSecondaryCta: "cc-hero-secondary-cta",
  heroTrustBar: "cc-hero-trust-bar",
  heroDashboard: "cc-hero-dashboard",

  problem: "cc-section-problem",
  whyMatters: "cc-section-why-matters",
  howItWorks: "cc-section-how-it-works",
  workspace: "cc-section-workspace",
  connected: "cc-section-connected",
  outcomes: "cc-section-outcomes",
  faq: "cc-section-faq",
  finalCta: "cc-section-final-cta",

  faqAccordion: "cc-faq-accordion",
  faqItem: (i) => `cc-faq-item-${i}`,

  finalPrimaryCta: "cc-final-primary-cta",
  finalSecondaryCta: "cc-final-secondary-cta",

  footer: "cc-footer",
};
